import { EventStream } from 'Roblox';
import { EventTypes, EventContext, EVENT_NAME, PLATFORM } from './eventConstants';

const sendNotApprovedPageEvent = (
  eventType: EventTypes,
  additionalProperties?: Record<string, string | number | boolean>
): void => {
  const baseProperties = {
    eventType,
    timestamp: Date.now(),
    platform: PLATFORM
  };

  EventStream.SendEventWithTarget(
    EVENT_NAME,
    EventContext.NotApprovedPage,
    // additionalProperties
    {
      ...baseProperties,
      ...additionalProperties
    },
    EventStream.TargetTypes.WWW
  );
};

export default sendNotApprovedPageEvent;
